export default {
  settings: {
    title: 'Cài đặt',
    account_related: 'Thông tin tài khoản',
    user_related: 'Thông tin người dùng',
    add_user_title: 'Thêm người dùng',
    edit_user_title: 'Chỉnh sửa người dùng',
    label: {
      enabled: 'Đã bật',
      not_set: 'Chưa đặt',
    },
    company: {
      title: 'Thông tin công ty',
      name: 'Tên công ty',
      english_name: 'English name',
      scale: 'Số lượng nhân viên',
      industry_type: 'Ngành',
      plan: 'Kế hoạch',
      location: 'Địa chỉ',
      allowed_ip: 'Địa chỉ IP được phép',
      mfa: 'Xác thực bằng SMS',
      sales_amount: 'Doanh thu',
      country: 'Quốc gia',
    },
    contract_plans: {
      buyer: 'Kế hoạch người mua',
      supplier: 'Kế hoạch nhà cung cấp',
    },
    user: {
      title: 'Danh sách người dùng',
      name: 'Tên',
      first_name: 'Tên',
      last_name: 'Họ',
      email: 'Địa chỉ email',
      email_unverified: 'Trước khi đăng ký',
      password: 'Mật khẩu',
      password_protection: 'Ẩn vì mục đích bảo mật',
      phone_number: 'Số điện thoại',
      role: {
        title: 'Quyền',
        admin: 'Quản trị viên',
        general: 'Chung',
      },
      locale: 'Chọn ngôn ngữ',
      action: 'Vận hành',
      total: 'Tất cả: {total} (Tối đa: {max})',
    },
    button: {
      create: 'Thêm người dùng',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【Chú ý】',
    cautions_01: 'Bạn không thể đổi địa chỉ email. Để đặt lại email, vui lòng tạo người dùng mới.',
    cautions_02: 'Cần có số điện thoại nếu kích hoạt xác thực SMS.',
    cautions_03: 'Để đặt lại mật khẩu, vui lòng nhập mã xác minh được gửi đến địa chỉ email đã đăng ký của bạn vào màn hình đặt lại mật khẩu.',
    cautions_04: 'Việc xóa người dùng sẽ không xóa dữ liệu câu trả lời hoặc phiếu ghi điểm.',
    messages: {
      user_update: 'Cập nhật thông tin người dùng',
      user_delete: 'Xóa người dùng',
      confirm_delete: 'Bạn có muốn xóa người dùng này không?',
      complete_create: 'Thông tin người dùng đã thêm thông.',
      complete_update: 'Thông tin người dùng đã được cập nhật.',
      complete_delete: 'Việc xóa thông tin người dùng đã hoàn tất.',
      disabled_delete: 'Ít nhất một người dùng phải có quyền "Quản trị viên".',
      disabled_delete_by_auth: 'Chỉ Quản trị viên mới có thể xóa.',
      invalid_form: 'Đầu vào không chính xác.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'Sau khi nhấp vào "THÊM", một email xác nhận sẽ được gửi đến địa chỉ email bạn đã nhập. \nSau đó, một email có chứa ID đăng nhập và mật khẩu sẽ được gửi đến.',
      caution_two: 'Cần có số điện thoại nếu kích hoạt xác thực SMS.',
      caution_three: 'Có thể thêm tối đa 5 người dùng.',
      user_add_title: '@:settings.button.create',
      user_add_message_one: 'Chúng tôi đã gửi email đến địa chỉ bạn cung cấp. ',
      user_add_message_two: 'Vui lòng kiểm tra email của bạn và làm theo hướng dẫn trong email để đăng nhập.',
    },
    tips: {
      role: 'Quyền "Quản trị viên" có thể thêm và xóa người dùng nhưng quyền "Chung" thì không thể.',
      locale: 'Bạn có thể chọn cài đặt ngôn ngữ ban đầu sau khi đăng nhập.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'Bạn có chắc chắn muốn đăng xuất và đi tới trang đặt lại mật khẩu không? Trên trang đặt lại mật khẩu, vui lòng nhập mã xác minh được cung cấp trong email gửi đến địa chỉ email đã đăng ký của bạn.',
      reset: 'Đặt lại mật khẩu',
    },
  },
}
